export default __webpack_public_path__ + "static/media/background2.68fda028.png";